// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs--L3Foo"};